import { message } from "antd";
import { AxiosError } from "axios";
import { getAssetEvolution, getAssetPerformanceEvolution, getPendingTransactions, getProductAllocation, getProductLists, getSchemeCapital, getTransactionsHitory, getUserBalance } from "src/api/http/account";
import { useAnalytics } from "./analytics.hook";

export const useAccount = () => {
  const { track } = useAnalytics();

  const getUserBalanceRequest = async (params?: any): Promise<any> => {
    try {

      let result: any;
      result = await getUserBalance(params);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };

  const getAssetEvolutionRequest = async (params?: any): Promise<any> => {
    try {

      let result: any;
      result = await getAssetEvolution(params);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };

  const getAssetPerformanceEvolutionRequest = async (params: any): Promise<any> => {
    try {

      let result: any;
      result = await getAssetPerformanceEvolution(params);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };

  const getProductListsRequest = async (params?: any): Promise<any> => {
    try {

      let result: any;
      result = await getProductLists(params);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };


  const getProductAllocationRequest = async (id: string): Promise<any> => {
    try {

      let result: any;
      result = await getProductAllocation(id);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };

  const getPendingTransactionsRequest = async (params?: any): Promise<any> => {
    try {

      let result: any;
      result = await getPendingTransactions(params);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };


  const getTransactionsHitoryRequest = async (params?: any): Promise<any> => {
    try {

      let result: any;
      result = await getTransactionsHitory(params);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };

  const getSchemeCapitalRequest = async (params: any): Promise<any> => {
    try {
      let result: any;
      result = await getSchemeCapital(params);
      return result?.data;
    } catch (error: any) {
      let info: string;
      if (error instanceof AxiosError) {
        info = error?.response?.data?.message || "";
      } else {
        info = error?.message || "";
      }
      message.error(info || "somethingWentWrong");
      track("Error", {
        page_current: "sign_in",
        error_message: info,
        error_code: info || "somethingWentWrong",
      });
    }
  };


  return {
    getUserBalance: getUserBalanceRequest,
    getAssetEvolution: getAssetEvolutionRequest,
    getAssetPerformanceEvolution: getAssetPerformanceEvolutionRequest,
    getProductLists: getProductListsRequest,
    getProductAllocation: getProductAllocationRequest,
    getPendingTransactions: getPendingTransactionsRequest,
    getTransactionsHitory: getTransactionsHitoryRequest,
    getSchemeCapital: getSchemeCapitalRequest
  };
};
